import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE, joinKw, CORE_KEYWORDS } from "@/seo/seoConfig";

const DEFAULT_DESCRIPTION =
  "RPLC UAE — Rane Pingle Law Chambers. Technology, VARA, UAE PDPL, DIFC, ADGM, DPDPA, AI governance, cyber law & cross-border corporate counsel across UAE, India and USA.";

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = CORE_KEYWORDS,
  image = SITE.defaultOgImage,
  path,
  type = "website",
  jsonLd,
  noindex = false,
  lang = "en",
}) {
  const loc = useLocation();
  const canonicalPath = path || loc.pathname || "/";
  const canonical = SITE.origin + canonicalPath;
  const fullTitle = title ? `${title} · ${SITE.brandShort}` : `${SITE.brandShort} — ${SITE.brand} · Technology. Regulation. Business. Across Borders.`;

  const kwString = joinKw(keywords);
  const structured = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={kwString} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" />}
      <link rel="canonical" href={canonical} />

      {/* Alternate languages */}
      <link rel="alternate" hrefLang="en" href={canonical} />
      <link rel="alternate" hrefLang="ar" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.brandShort} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_AE" />
      <meta property="og:locale:alternate" content="en_IN" />
      <meta property="og:locale:alternate" content="ar_AE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geo — primary (UAE) */}
      <meta name="geo.region" content="AE-DU" />
      <meta name="geo.placename" content="Dubai" />
      <meta name="geo.position" content="25.1972;55.2744" />
      <meta name="ICBM" content="25.1972, 55.2744" />

      {structured.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
